import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { RecipeEditor } from '../features/recipes/RecipeEditor.tsx';
import { RecipeLoadError } from '../features/recipes/RecipeLoadError.tsx';
import { recipeQuery } from '../lib/recipes.ts';

export const Route = createFileRoute('/recipes/$id_/edit')({ component: EditRecipeScreen });

function EditRecipeScreen() {
  const { id } = Route.useParams();
  const recipe = useQuery(recipeQuery(id));
  if (recipe.isError) return <RecipeLoadError error={recipe.error} />;
  if (!recipe.data) return <div className="splash" aria-busy="true" />;
  // Keyed so a refetch doesn't reset the form mid-edit.
  return <RecipeEditor key={recipe.data.id} recipe={recipe.data} />;
}
